function navigationAccordion() {
  /*
    navigationAccordion behaviour

    - Mobile / tablet (< 1200px):
      * menu toggles (menu__menuitem) are opened by clicking the icon
      * dropdown tabs (.dropdown--with-tabs li > span) toggle on click

    - Desktop (>=1200px):
      * dropdown tabs open on hover (mouseenter) and remain active until another sibling is hovered
      * keyboard interaction on desktop is intentionally omitted (hover-only behavior)
      * aria-expanded is set on each tab <li> for accessibility
  */

  try {
    // We need different behaviours depending on viewport:
    // - Mobile/tablet (<1200px): click to toggle dropdowns / tabs
    // - Desktop (>=1200px): dropdowns are handled elsewhere, but tabs should open on hover

    // Find all menu items that have a dropdown (mobile behaviour only)
    let menuItems = document.querySelectorAll(".menu__menuitem");

    if (window.innerWidth < 1200) {
      menuItems.forEach(function (item) {
        let icon = item.querySelector(".menu__menuitem__icon");
        let dropdown = item.querySelector(".dropdown__itemsWrapper");

        // Only add listeners if both icon and dropdown exist
        if (icon && dropdown) {
          // Set initial height to 0
          dropdown.style.height = "0px";
          dropdown.style.overflow = "hidden";
          
          icon.addEventListener("click", function (e) {
            e.stopPropagation();
            e.preventDefault();

            // Toggle the dropdown
            let isOpen = item.classList.contains("active");

            if (isOpen) {
              // Close this dropdown
              item.classList.remove("active");
              icon.classList.remove("open");
              item.setAttribute("aria-expanded", "false");
              dropdown.style.height = "0px";
            } else {
              // Close all other dropdowns in the same menu
              let menuContainer = item.closest(".menu");
              if (menuContainer) {
                let allMenuItems = menuContainer.querySelectorAll(".menu__menuitem.active");
                allMenuItems.forEach(function (activeItem) {
                  // Close other menu items
                  activeItem.classList.remove("active");
                  let activeIcon = activeItem.querySelector(".menu__menuitem__icon");
                  if (activeIcon) activeIcon.classList.remove("open");
                  activeItem.setAttribute("aria-expanded", "false");
                  
                  // Reset height of other dropdowns
                  let activeDropdown = activeItem.querySelector(".dropdown__itemsWrapper");
                  if (activeDropdown) {
                    activeDropdown.style.height = "0px";
                  }
                });
              }

              // Open this dropdown
              item.classList.add("active");
              icon.classList.add("open");
              item.setAttribute("aria-expanded", "true");
              
              // Calculate and set height
              dropdown.style.height = "auto";
              let height = dropdown.scrollHeight;
              dropdown.style.height = "0px";
              
              // Trigger reflow
              dropdown.offsetHeight;
              
              dropdown.style.height = height + "px";
            }
          });
        }
      });
    }

    // Mobile: keep click-to-toggle behaviour for tabs
    if (window.innerWidth < 1200) {
      document.addEventListener("click", function (e) {
        let tabSpan = e.target.closest(".dropdown--with-tabs .dropdown__content > ul > li > span");

        if (!tabSpan) return;

        e.stopPropagation();
        e.preventDefault();

        let tabItem = tabSpan.closest("li");
        let dropdownItems = tabItem.querySelector(".dropdown__items");
        let dropdown = tabSpan.closest(".dropdown--with-tabs");

        if (!tabItem || !dropdownItems || !dropdown) return;

        // Toggle current tab
        let isOpen = tabItem.classList.contains("active");

        if (isOpen) {
          // Close this tab - only class and aria changes
          tabItem.classList.remove("active");
          tabItem.setAttribute("aria-expanded", "false");
        } else {
          // Close all other tabs in THIS specific dropdown only
          let allTabs = dropdown.querySelectorAll(".dropdown__content > ul > li.active");
          allTabs.forEach(function (activeTab) {
            // Only remove classes / aria — styles are handled by CSS
            activeTab.classList.remove("active");
            activeTab.setAttribute("aria-expanded", "false");
          });

          // Open this tab (class/aria only) — CSS should manage the visual
          tabItem.classList.add("active");
          tabItem.setAttribute("aria-expanded", "true");
        }
      });

      // Mobile: inner-icon click should behave like an accordion for dropdown__items
      // (iPad Pro and below). Clicking an inner-icon toggles its sibling .dropdown__items
      // by adding/removing the `active` class on the parent li and using maxHeight.
      let innerIcons = document.querySelectorAll(".dropdown__content .inner-icon");
      innerIcons.forEach(function (icon) {
        icon.addEventListener("click", function (ev) {
          ev.stopPropagation();
          ev.preventDefault();

          // Find the parent list item that contains the dropdown__items
          let li = icon.closest("li");
          if (!li) return;

          let items = li.querySelector(".dropdown__items");
          if (!items) return;

          let isOpen = li.classList.contains("active");

          if (isOpen) {
            // Close it — only toggle class/aria; styles are handled in CSS
            li.classList.remove("active");
            li.setAttribute("aria-expanded", "false");
          } else {
            // Close other open siblings in the same list (class-only)
            let container = li.parentElement;
            if (container) {
              let openSiblings = container.querySelectorAll("li.active");
              openSiblings.forEach(function (s) {
                if (s === li) return;
                s.classList.remove("active");
                s.setAttribute("aria-expanded", "false");
              });
            }

            // Open this — class-only; CSS will handle display/animation
            li.classList.add("active");
            li.setAttribute("aria-expanded", "true");
          }
        });
      });
    } else {
      // Desktop: open tabs on hover (mouseenter) and keep active until another sibling is hovered
      let desktopDropdowns = document.querySelectorAll(".dropdown--with-tabs");
      desktopDropdowns.forEach(function (dropdown) {
        let tabLis = dropdown.querySelectorAll(".dropdown__content > ul > li");

        // Ensure the FIRST tab is active on desktop by default
        // — clear other active states and set the first <li> as active.
        if (tabLis.length) {
          // remove active from all to guarantee a single active tab
          tabLis.forEach(function (li) {
            li.classList.remove("active");
            li.setAttribute("aria-expanded", "false");
          });

          // make the first tab active
          const first = tabLis[0];
          first.classList.add("active");
          first.setAttribute("aria-expanded", "true");
        }
        tabLis.forEach(function (tabItem) {
          let dropdownItems = tabItem.querySelector(".dropdown__items");
          if (!dropdownItems) return;

          // On desktop we use hover only — do not add focus/keyboard activation.
          // Avoid making the tab header focusable so clicks or focus don't apply active.

          // Open on hover
          tabItem.addEventListener("mouseenter", function (e) {
            // Close other tabs in this dropdown
            let allTabs = dropdown.querySelectorAll(".dropdown__content > ul > li.active");
            allTabs.forEach(function (activeTab) {
              if (activeTab === tabItem) return;
              activeTab.classList.remove("active");
              // Do not touch inline height on desktop; we only manage the class and ARIA
              let activeItems = activeTab.querySelector(".dropdown__items");
              if (activeItems) {
                // leave layout/styling to CSS for desktop
              }
              activeTab.setAttribute("aria-expanded", "false");
            });

            // Open hovered tab
            tabItem.classList.add("active");
            // Note: On desktop we intentionally do NOT set inline styles for max-height.
            // The visual open/close should be handled by CSS using the `.active` class.
            tabItem.setAttribute("aria-expanded", "true");
          });

          // NOTE: do NOT remove active on mouseleave for desktop.
          // The UI should keep the hovered tab `active` until another sibling is hovered.
          // Therefore, we do not close on mouseleave here.

          // Keyboard interaction is intentionally omitted on desktop: tabs are
          // activated by hover only and remain active until another sibling is hovered.
        });
      });
    }

    // Set initial state for tabs
    let allDropdownsWithTabs = document.querySelectorAll(".dropdown--with-tabs");
    allDropdownsWithTabs.forEach(function (dropdown) {
      let activeTabItems = dropdown.querySelectorAll(".dropdown__content > ul > li.active");
      activeTabItems.forEach(function (tabItem) {
        // Only set aria-expanded initially — leave all visuals to CSS
        tabItem.setAttribute("aria-expanded", tabItem.classList.contains("active") ? "true" : "false");
      });

      let inactiveTabItems = dropdown.querySelectorAll(".dropdown__content > ul > li:not(.active)");
      inactiveTabItems.forEach(function (tabItem) {
        // Ensure aria for inactive items, visual state is handled via CSS
        tabItem.setAttribute("aria-expanded", "false");
      });
    });
  } catch (error) {
    console.error("Navigation accordion error:", error);
  }
}

export default navigationAccordion;
